export default __webpack_public_path__ + "static/media/dexpad.0fd2f342.svg";